import React from 'react';
import DemoFrame from './DemoFrame';
import useDemoPlayer from './useDemoPlayer';
import { DEMO_CLASS, DEMO_SCORING } from './demoFixtures';

const S = DEMO_SCORING;

// 0 스캔 PDF 감지 → 1 학생 범위 찾는 중 → 2 범위 나눔 → 3 답안 확인 → 4 근거 표시 + 점수 → 5(완성) 항목별 점수
const STEPS = [1000, 1200, 1600, 900, 1700];

const ScoringScanDemo = ({ surface = 'home', title = '서술형 채점', autoStart = false }) => {
  const player = useDemoPlayer({ steps: STEPS, surface, feature: 'scoring_scan', autoStart });
  const { phase, done } = player;
  const reviewing = phase >= 3;
  const highlighted = phase >= 4;

  return (
    <DemoFrame title={title} player={player}>
      {!reviewing ? (
        <div>
          <div className="wqdemo-file-chip">
            <span className="wqdemo-file-icon">PDF</span>
            <span>
              {S.fileName}
              <em> · {S.pages}페이지 스캔 PDF 감지</em>
            </span>
          </div>
          {phase >= 1 && (
            <div className="wqdemo-ranges wqdemo-in">
              {phase === 1 ? (
                <>
                  <strong>AI가 학생별 페이지 범위를 찾고 있어요</strong>
                  <div className="wqdemo-skeleton" style={{ width: '90%' }} />
                  <div className="wqdemo-skeleton" style={{ width: '70%' }} />
                </>
              ) : (
                <>
                  <strong>{DEMO_CLASS.size}명 범위로 나눴어요</strong>
                  <ul>
                    {S.ranges.map((r) => (
                      <li key={r.name}>
                        {r.name}
                        <span>{r.pages}</span>
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </div>
          )}
        </div>
      ) : (
        <div className="wqdemo-review wqdemo-in">
          <div className="wqdemo-paper">
            <p className="wqdemo-paper-q">{S.ranges[0].name} · {S.ranges[0].pages} · {S.question}</p>
            <p className="wqdemo-paper-a">
              {S.answer.map((seg, i) => (
                seg.hl ? (
                  // eslint-disable-next-line react/no-array-index-key
                  <span key={i} className={`wqdemo-hl${highlighted ? ' is-on' : ''}`}>{seg.t}</span>
                ) : (
                  // eslint-disable-next-line react/no-array-index-key
                  <React.Fragment key={i}>{seg.t}</React.Fragment>
                )
              ))}
            </p>
          </div>
          {highlighted ? (
            <div className="wqdemo-verdict wqdemo-in">
              <span>채점 판단</span>
              <b>{S.score}점 <small>/ {S.max}점</small></b>
            </div>
          ) : (
            <div className="wqdemo-verdict">
              <span>채점하고 있어요</span>
              <b><small>…</small></b>
            </div>
          )}
          {done && (
            <ul className="wqdemo-criteria wqdemo-in">
              {S.criteria.map((c) => (
                <li key={c.name}>
                  {c.name}
                  <b>{c.score}/{c.max}</b>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </DemoFrame>
  );
};

export default ScoringScanDemo;
